import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosCollapse } from './collapse'
import { IcosCollapseItem } from './collapse-item'


@NgModule({
  declarations: [IcosCollapse, IcosCollapseItem],
  exports: [IcosCollapse, IcosCollapseItem],
  imports: [CommonModule],
  entryComponents: [IcosCollapse],
})
export class IcosCollapseModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosCollapseModule, providers: [] }
  }
}
